import { render } from "./Area-SucursalForm-Component.vue?vue&type=template&id=f8f6694c"
import script from "./Area-SucursalForm-Component.vue?vue&type=script&lang=js"
export * from "./Area-SucursalForm-Component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__